import { Box } from '@mui/material';
import { FC } from 'react';
import InlineToast from '../toasts/inline';

const PortalDeprecatedToast: FC = () => {
  return (
    <Box mb={4}>
      <InlineToast
        level="warning"
        message="Portal Chat is now deprecated, and will be removed entirely in a future release. If you wish to enable this feature, or for help finding an alternative, please contact support."
      />
    </Box>
  );
};

export default PortalDeprecatedToast;
